<template>
  <v-app>
    <div id="app">
      <BaseSnackbar top right :data="snackbar" />
      <TheLayout v-if="isAuthenticated" />
      <TheSimpleLayout v-else />
      <ModalSilentOperatorWarning
        v-if="pendingSilentOperatorWarning"
        :show="showSilentOperatorWarning"
        :warning="pendingSilentOperatorWarning"
        :disabled="warningRequestPending"
        @accept="respondToSilentOperatorWarning('accepted')"
        @decline="respondToSilentOperatorWarning('declined')"
        @timeout="respondToSilentOperatorWarning('timeout')"
      />
    </div>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import TheLayout from "./components/TheLayout";
import TheSimpleLayout from "./components/TheSimpleLayout";
import BaseSnackbar from "@/components/BaseSnackbar";
import ModalSilentOperatorWarning from "@/components/ModalSilentOperatorWarning";
import employeeApi from "@/api/employee";
import apiSocketService from "@/services/apiSocket";
import { mapActions } from "vuex";

export default {
  name: "app",
  data() {
    return {
      warningRequestPending: false,
      warningArmRetry: null,
    };
  },
  computed: {
    ...mapState({
      snackbar: state => state.common.snackbar,
      pendingSilentOperatorWarning: state => state.common.silentOperatorWarning,
      currentOrder: state => state.order.order,
      isOrderOpened: state => state.order.isOrderOpened,
    }),
    isAuthenticated() {
      return this.$auth.isAuthenticated();
    },
    showSilentOperatorWarning() {
      return Boolean(
        this.isAuthenticated
        && this.pendingSilentOperatorWarning
        && (!this.currentOrder || !this.isOrderOpened)
        && !this.$store.getters.getPhoneHasActiveCall
      );
    },
  },
  methods: {
    ...mapActions(['autoLoginByToken']),
    setUserLocale(locale) {
      window.localStorage.setItem("locale", locale);
    },
    async armSilentOperatorWarning() {
      const warning = this.pendingSilentOperatorWarning;
      const warningTimerArmed = warning && (
        (
          warning.responseSecondsLeft !== null
          && typeof warning.responseSecondsLeft !== "undefined"
        )
        || Boolean(warning.responseDeadlineAt)
      );
      if (
        !this.showSilentOperatorWarning
        || !warning
        || warningTimerArmed
        || this.warningRequestPending
      ) {
        return;
      }

      this.warningRequestPending = true;
      const incidentId = warning.incidentId;
      try {
        const response = await employeeApi.respondSilentOperatorWarning(incidentId, "shown");
        const result = response.data.data.silent_operator_warning;
        if (result.warning) {
          this.$store.commit("SET_SILENT_OPERATOR_WARNING", result.warning);
        } else if (result.status === "accepted") {
          this.$store.commit("CLEAR_SILENT_OPERATOR_WARNING", incidentId);
          apiSocketService.handleFetchOrderCommand();
        }
      } catch (error) {
        this.warningArmRetry = setTimeout(() => {
          this.warningArmRetry = null;
          this.armSilentOperatorWarning();
        }, 5000);
      } finally {
        this.warningRequestPending = false;
      }
    },
    async respondToSilentOperatorWarning(action) {
      const warning = this.pendingSilentOperatorWarning;
      if (!warning || this.warningRequestPending) {
        return;
      }

      this.warningRequestPending = true;
      try {
        const response = await employeeApi.respondSilentOperatorWarning(
          warning.incidentId,
          action
        );
        const result = response.data.data.silent_operator_warning;
        if (result.status === "pending" && result.warning) {
          this.$store.commit("SET_SILENT_OPERATOR_WARNING", result.warning);
          return;
        }

        if (result.status === "accepted") {
          this.$store.commit("CLEAR_SILENT_OPERATOR_WARNING", warning.incidentId);
          apiSocketService.handleFetchOrderCommand();
          return;
        }

        this.$store.commit("CLEAR_SILENT_OPERATOR_WARNING", warning.incidentId);
        apiSocketService.handleForceLogoutCommand({
          reason: `silent_operator_warning_${result.status || action}`,
        });
      } catch (error) {
        if (action === "declined" || action === "timeout") {
          apiSocketService.handleForceLogoutCommand({
            reason: `silent_operator_warning_${action}_client`,
          });
          return;
        }
        this.$store.commit("SET_SNACKBAR_DATA", {
          type: "error",
          text: "Не удалось сохранить ответ. Попробуйте еще раз.",
        });
      } finally {
        this.warningRequestPending = false;
      }
    },
  },
  components: {
    TheLayout,
    TheSimpleLayout,
    BaseSnackbar,
    ModalSilentOperatorWarning
  },
  watch: {
    showSilentOperatorWarning: {
      immediate: true,
      handler(show) {
        if (show) {
          this.$nextTick(() => this.armSilentOperatorWarning());
        }
      },
    },
    "$route.query": {
      immediate: true,
      handler() {
        if (! this.$auth.isAutoLoginDoNotMatch()) {
          return;
        }

        this.autoLoginByToken({vm: this}).then(() => {
          if (this.$auth.isAuthenticated()) {
               location.reload();
          }
        });
      }
    },
  },
  beforeDestroy() {
    if (this.warningArmRetry) {
      clearTimeout(this.warningArmRetry);
    }
  },
};
</script>

<style lang="scss"></style>
